// @ts-nocheck
/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gb2_assistantsalesorder_contact_nocontactdescription4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please choose the contact manually, or enter new contact details in the order summary below.`)
};

const en_us2_assistantsalesorder_contact_nocontactdescription4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please choose the contact manually, or enter new contact details in the order summary below.`)
};

const de_de2_assistantsalesorder_contact_nocontactdescription4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wählen Sie den entsprechenden Kontakt manuell aus, oder geben Sie neue Kontaktdaten in der Bestellübersicht an.`)
};

const en_assistantsalesorder_contact_nocontactdescription4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please choose the contact manually, or enter new contact details in the order summary below.`)
};

const de_assistantsalesorder_contact_nocontactdescription4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wählen Sie den entsprechenden Kontakt manuell aus, oder geben Sie neue Kontaktdaten in der Bestellübersicht an.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en-GB" | "en-US" | "de-DE" | "en" | "de" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const assistantsalesorder_contact_nocontactdescription4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.assistantsalesorder_contact_nocontactdescription4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("assistantsalesorder_contact_nocontactdescription4", locale)
	if (locale === "en-GB") return en_gb2_assistantsalesorder_contact_nocontactdescription4(inputs)
	if (locale === "en-US") return en_us2_assistantsalesorder_contact_nocontactdescription4(inputs)
	if (locale === "de-DE") return de_de2_assistantsalesorder_contact_nocontactdescription4(inputs)
	if (locale === "en") return en_assistantsalesorder_contact_nocontactdescription4(inputs)
	return de_assistantsalesorder_contact_nocontactdescription4(inputs)
};
export { assistantsalesorder_contact_nocontactdescription4 as "assistantSalesOrder.contact.noContactDescription" }